import { render, staticRenderFns } from "./TradeWatcher.vue?vue&type=template&id=fc35861c&scoped=true"
import script from "./TradeWatcher.vue?vue&type=script&lang=js"
export * from "./TradeWatcher.vue?vue&type=script&lang=js"
import style0 from "../css/utilities/scoped/tradeWatcher.css?vue&type=style&index=0&id=fc35861c&scoped=true&lang=css&external"
import style1 from "../css/utilities/tradeWatcher.css?vue&type=style&index=1&lang=css&external"
import style2 from "./TradeWatcher.vue?vue&type=style&index=2&id=fc35861c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc35861c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc35861c')) {
      api.createRecord('fc35861c', component.options)
    } else {
      api.reload('fc35861c', component.options)
    }
    module.hot.accept("./TradeWatcher.vue?vue&type=template&id=fc35861c&scoped=true", function () {
      api.rerender('fc35861c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TradeWatcher.vue"
export default component.exports